import { ASSETS_BASE_URL } from "../config";

// themeColors.js
export const themeColors = {
	blue: {
		light: "#ff2121",
		main: "#ed1f27",
		dark: "#b21717",
		contrastText: "#fff",
	},
	red: {
		light: "#FFCDD2",
		main: "#F44336",
		dark: "#D32F2F",
		contrastText: "#fff",
	},
	orange: {
		light: "#FFE0B2",
		main: "#FF9800",
		dark: "#F57C00",
		contrastText: "#fff",
	},
	cyan: {
		light: "#B2EBF2",
		main: "#00BCD4",
		dark: "#0097A7",
		contrastText: "#fff",
	},
};


export const fonts = {
	Poppins: "'Poppins', sans-serif",
	Inter: "'Inter', sans-serif",
	Roboto: "'Roboto', sans-serif",
	Montserrat: "'Montserrat', sans-serif",
	Lato: "'Lato', sans-serif",
	"Open Sans": "'Open Sans', sans-serif",
	Rift: "'Rift', sans-serif",
	Merriweather: "'Merriweather', serif",
};

export const AuthPageStyles = {
	backgroundImage: `
			linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
			url('${ASSETS_BASE_URL}/home_bg2.jpg')
		`,
	backgroundSize: "cover",
	backgroundPosition: "center",
};

// Deployment-specific Site Services configuration.
// Update this array per environment to control which switches appear in Manage Sites form.
export const siteServiceOptions = [
	{ key: "service_plan", label: "Service Plan" },
	{ key: "amfmethod_premium", label: "AMFPremium", href: "https://amf-bakery-0355.reach360.com/login" },
	{ key: "sustainable_oven_service", label: "Sustainable Oven Service" },
	{ key: "machine_dashboard_ixon", label: "Machine Dashboard (IXON)" },
	{ key: "predictive_maintenance", label: "Predictive Maintenance" },
];
